import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://6ff6675949c5eba1c3b94336beda6d54@o4508518257459200.ingest.us.sentry.io/4508539778760704",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});
